import React, { useContext, useEffect } from 'react';
import './importLoad.css';
import information from '../../../images/information.svg';
import { StoreContext } from '../../Store';
import FileLoader from './FileLoader';

const ImportNewLoad = () => {
  const store = useContext(StoreContext);

  useEffect(() => {
    store.resetNewLoad();
  }, []);

  return (
    <div className="semi-fluid-container container-xl file-upload" style={{ maxWidth: '700px', marginTop: '4rem' }}>
      <div className="floating-box-newload">
        <h1 className="floating-box-header-newload">
          <span>Submit load file</span>
        </h1>
        <div id="load-info-form" className="fileloader-header">
          <div className="inputs-group">
            <span className="more-info">
              <img src={information} height="" width="30" alt="info" />
              &nbsp;&nbsp;
              <span>{store.infoText[0]}</span>
            </span>
          </div>
          <div className="inputs-group">
            <FileLoader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportNewLoad;
